// extracted by mini-css-extract-plugin
module.exports = {"UniversalPage":"styles_UniversalPage__V4reY"};